import React, { useState, useEffect } from 'react';
import { CalendarCheck } from 'lucide-react';
import { PORTAL_URL } from '../SiteLayout';
import PageSEO from '../../components/PageSEO';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DOCTOR_PLACEHOLDER = '/doctor-placeholder.svg';

// Photos that are known placeholders (from legacy seeds) should never appear.
const isPlaceholderUrl = (url) =>
  !url || /via\.placeholder|placehold\.co|cmt_logo/i.test(url);

export default function SiteDoctors() {
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/doctors`)
      .then(r => r.json())
      .then(d => setDoctors((d.doctors || []).filter(doc => !doc.name.toLowerCase().includes('test'))))
      .catch(() => {});
  }, []);

  return (
    <main data-testid="site-doctors">
      <PageSEO
        title="Notre équipe médicale — Matadi & Boma"
        description="Découvrez nos médecins spécialistes à Matadi et Boma (RDC) : gynécologie-obstétrique, chirurgie, pédiatrie, médecine interne, anesthésie-réanimation. Prise de rendez-vous en ligne."
        path="/medecins"
      />
      <div className="site-page-head">
        <div className="site-page-head-inner">
          <h1 className="site-reveal">Une équipe médicale à votre service</h1>
          <p className="site-reveal-1">
            Le Centre Médical la Trinité rassemble une équipe pluridisciplinaire de médecins,
            de sages-femmes, d&apos;infirmiers, de techniciens de laboratoire, de manipulateurs d&apos;imagerie
            et de personnels administratifs, unis par une même exigence : offrir à chaque patient
            une prise en charge de qualité, respectueuse et humaine. Nos praticiens exercent leur
            spécialité avec rigueur, en s&apos;appuyant sur des équipements modernes, une organisation
            structurée et une démarche continue d&apos;amélioration des pratiques.
          </p>
        </div>
      </div>

      <section className="site-section">
        <div style={{ maxWidth: 900, margin: '0 auto 2rem', textAlign: 'center' }}>
          <span className="site-kicker">Nos praticiens</span>
          <h2>Retrouvez les médecins du Centre</h2>
          <p style={{ color: 'var(--site-muted)' }}>
            Sélectionnez un praticien pour prendre rendez-vous, en consultation présentielle ou en téléconsultation.
          </p>
        </div>
        <div className="site-grid" data-testid="site-doctors-grid">
          {doctors.map(doc => (
            <div className="site-doctor-card" key={doc.doctor_id} data-testid={`site-doctor-${doc.doctor_id}`}>
              <img
                src={isPlaceholderUrl(doc.photo_url) ? DOCTOR_PLACEHOLDER : doc.photo_url}
                alt={doc.name}
                loading="lazy"
                onError={(e) => { e.target.onerror = null; e.target.src = DOCTOR_PLACEHOLDER; }}
              />
              <div className="site-doctor-body">
                <h3>{doc.name}</h3>
                <div className="site-doctor-spec">{doc.specialty}</div>
                <p>{doc.bio}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="site-cta-band" style={{ marginTop: '3.4rem' }}>
          <div>
            <h2>Consultez le médecin de votre choix</h2>
            <p>Sélectionnez votre service, puis le médecin correspondant à votre besoin lors de la prise de rendez-vous.</p>
          </div>
          <a href={`${PORTAL_URL}?page=booking`} className="site-btn site-btn-outline" style={{ background: 'white' }} data-testid="doctors-cta-booking-btn">
            <CalendarCheck size={18} /> Prendre rendez-vous
          </a>
        </div>
      </section>
    </main>
  );
}
